
import type { PropType } from 'vue'
import type { BrowseFacetValueDTO } from '../../models'
import Sortable from 'sortablejs'

import { defineComponent, ref, watch } from 'vue'

import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'EpbRecursiveFacetValues',
  components: { EpbText },
  props: {
    facetValues: {
      type: Array as PropType<BrowseFacetValueDTO[]>,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
    level: Number,
    draggable: Boolean,
  },
  setup(props, ctx) {
    const baseClass = 'epb-recursive-facet-values'

    const { emit } = ctx

    const intervalItems = 8

    const container = ref(null)

    const numValues = ref(intervalItems)

    const values = ref(props.facetValues)

    const levelValue = ref(props.level)

    const newFacetValuesOrder = ref([])

    watch(
      () => container.value,
      () => {
        if (container.value && props.draggable) {
          new Sortable(container.value, {
            animation: 150,
            onEnd: ({ oldIndex, newIndex }) => {
              const itemToMove = values.value.splice(oldIndex, 1)[0]
              values.value.splice(newIndex, 0, itemToMove)
              if (
                newFacetValuesOrder.value.length > newIndex &&
                newFacetValuesOrder.value.length > oldIndex
              ) {
                newFacetValuesOrder.value = values.value.slice(0, newFacetValuesOrder.value.length)
              } else if (oldIndex < newIndex) {
                newFacetValuesOrder.value = values.value.slice(0, newIndex + 1)
              } else {
                newFacetValuesOrder.value = values.value.slice(0, oldIndex)
              }
              emit('updateFacetValues', newFacetValuesOrder.value)
            },
          })
        }
      },
    )

    watch(
      () => props.facetValues,
      () => {
        values.value = props.facetValues
      },
      { immediate: true },
    )

    return {
      baseClass,
      container,
      intervalItems,
      numValues,
      values,
      levelValue,
    }
  },
})
